(ns teamoesterreich.firebase.remote-config
  (:require
    [clojure.string :as str]
    [teamoesterreich.firebase.firebase :as fb]
    ))

fb/app

; Future 8.x
(def fs-remoteConfig (.remoteConfig js/firebase))
(set! (.. fs-remoteConfig -settings -minimumFetchIntervalMillis) 500000)

(.fetchAndActivate fs-remoteConfig)
(.then (.ensureInitialized fs-remoteConfig) (js/console.log " " (.getString fs-remoteConfig "help_card_online")))

(defn get-string>> [key cb-fn]
  (.then (.ensureInitialized fs-remoteConfig)
         (cb-fn (.getString fs-remoteConfig key))))

(defn get-string [key]
  (.getString fs-remoteConfig key))

(defn get-boolean [key]
  (.getBoolean fs-remoteConfig key))

(defn get-number [key]
  (.getNumber fs-remoteConfig key))

(defn get-value [key]
  (.getValue fs-remoteConfig key))

